import React from 'react';
import styled from 'styled-components';

const TimeIntervalWarning = styled.div`
  word-wrap: break-word;
  font-size: 11px;
  padding: 0 12px;
  width: 220px;
  
`;

export default TimeIntervalWarning;
